export const imageToCanvas = (img: HTMLImageElement): HTMLCanvasElement => {
	const canvas = document.createElement("canvas");
	canvas.width = img.width;
	canvas.height = img.height;
	const ctx = canvas.getContext("2d");
	ctx?.drawImage(img, 0, 0);
	return canvas;
};
